import { render } from "./BasicTextArea.vue?vue&type=template&id=47475256"
import script from "./BasicTextArea.vue?vue&type=script&lang=js"
export * from "./BasicTextArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__